import NavigationTabs from './NavigationTabsContainer.vue';

export { NavigationTabs };


// WEBPACK FOOTER //
// ./src/modules/home/NavigationTabs/index.js